import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SegmentPool_instance23prvj6kllmmf as SegmentPool_instance } from './SegmentPool.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.a3w_1 = 8192;
        this.b3w_1 = 1024;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function init_okio_Segment(_this__u8e3s4) {
  _this__u8e3s4.d3w_1 = 0;
  _this__u8e3s4.e3w_1 = 0;
  _this__u8e3s4.f3w_1 = false;
  _this__u8e3s4.g3w_1 = false;
  _this__u8e3s4.h3w_1 = null;
  _this__u8e3s4.i3w_1 = null;
}
var SegmentClass;
function Segment() {
  if (SegmentClass === VOID) {
    class $ {
      static j3w() {
        var $this = createThis(this);
        init_okio_Segment($this);
        $this.c3w_1 = new Int8Array(8192);
        $this.g3w_1 = true;
        $this.f3w_1 = false;
        return $this;
      }
      static k3w(data, pos, limit, shared, owner) {
        var $this = createThis(this);
        init_okio_Segment($this);
        $this.c3w_1 = data;
        $this.d3w_1 = pos;
        $this.e3w_1 = limit;
        $this.f3w_1 = shared;
        $this.g3w_1 = owner;
        return $this;
      }
      l3w() {
        this.f3w_1 = true;
        return Segment().k3w(this.c3w_1, this.d3w_1, this.e3w_1, true, false);
      }
      m3w() {
        var result = !(this.h3w_1 === this) ? this.h3w_1 : null;
        ensureNotNull(this.i3w_1).h3w_1 = this.h3w_1;
        ensureNotNull(this.h3w_1).i3w_1 = this.i3w_1;
        this.h3w_1 = null;
        this.i3w_1 = null;
        return result;
      }
      n3w(segment) {
        segment.i3w_1 = this;
        segment.h3w_1 = this.h3w_1;
        ensureNotNull(this.h3w_1).i3w_1 = segment;
        this.h3w_1 = segment;
        return segment;
      }
      o3w(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount > 0 && byteCount <= (this.e3w_1 - this.d3w_1 | 0))) {
          var message = 'byteCount out of range';
          throw IllegalArgumentException().n2(toString(message));
        }
        var prefix;
        if (byteCount >= 1024) {
          prefix = this.l3w();
        } else {
          prefix = SegmentPool_instance.r3w();
          var tmp0 = this.c3w_1;
          var tmp2 = prefix.c3w_1;
          var tmp5 = this.d3w_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = this.d3w_1 + byteCount | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
        }
        prefix.e3w_1 = prefix.d3w_1 + byteCount | 0;
        this.d3w_1 = this.d3w_1 + byteCount | 0;
        ensureNotNull(this.i3w_1).n3w(prefix);
        return prefix;
      }
      s3w() {
        // Inline function 'kotlin.check' call
        if (!!(this.i3w_1 === this)) {
          var message = 'cannot compact';
          throw IllegalStateException().o(toString(message));
        }
        if (!ensureNotNull(this.i3w_1).g3w_1)
          return Unit_instance;
        var byteCount = this.e3w_1 - this.d3w_1 | 0;
        var availableByteCount = (8192 - ensureNotNull(this.i3w_1).e3w_1 | 0) + (ensureNotNull(this.i3w_1).f3w_1 ? 0 : ensureNotNull(this.i3w_1).d3w_1) | 0;
        if (byteCount > availableByteCount)
          return Unit_instance;
        this.t3w(ensureNotNull(this.i3w_1), byteCount);
        this.m3w();
        SegmentPool_instance.u3w(this);
      }
      t3w(sink, byteCount) {
        // Inline function 'kotlin.check' call
        if (!sink.g3w_1) {
          var message = 'only owner can write';
          throw IllegalStateException().o(toString(message));
        }
        if ((sink.e3w_1 + byteCount | 0) > 8192) {
          if (sink.f3w_1)
            throw IllegalArgumentException().od();
          if (((sink.e3w_1 + byteCount | 0) - sink.d3w_1 | 0) > 8192)
            throw IllegalArgumentException().od();
          var tmp0 = sink.c3w_1;
          var tmp2 = sink.c3w_1;
          var tmp5 = sink.d3w_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = sink.e3w_1;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
          sink.e3w_1 = sink.e3w_1 - sink.d3w_1 | 0;
          sink.d3w_1 = 0;
        }
        var tmp0_0 = this.c3w_1;
        var tmp2_0 = sink.c3w_1;
        var tmp4 = sink.e3w_1;
        var tmp6 = this.d3w_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_0 = this.d3w_1 + byteCount | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = tmp0_0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp_0, tmp2_0, tmp4, tmp6, endIndex_0);
        sink.e3w_1 = sink.e3w_1 + byteCount | 0;
        this.d3w_1 = this.d3w_1 + byteCount | 0;
      }
    }
    initMetadataForClass($, 'Segment', $.j3w);
    SegmentClass = $;
  }
  return SegmentClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Segment as Segmentnhwb43ukbiy3,
};
//endregion

//# sourceMappingURL=Segment.mjs.map
